/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import {
    dashboardRoute, useradminRoute, authorizationRoute, licenseRoute, manualRoute, userRoleRoute,
    bulletinRoute, GSInfoRoute, laborTimeGuideRoute, downloadsRoute, instrumentConstantsRoute
} from './constants';

export const routes: any = [
  { route: dashboardRoute, routename: 'dashboard' },
  { route: userRoleRoute, routename: 'useradmin/userrole' },
  { route: useradminRoute, routename: 'useradmin' },
  { route: authorizationRoute, routename: 'authorization' },
  { route: licenseRoute, routename: 'license' },
  { route: manualRoute, routename: 'manual' },
  { route: bulletinRoute, routename: 'bulletins' },
  { route: GSInfoRoute, routename: 'gsinfo' },
  { route: laborTimeGuideRoute, routename: 'labortimeguide' },
  { route: downloadsRoute, routename: 'downloads' },
  { route: instrumentConstantsRoute, routename: 'instrumentconstants' }
]